import {
  type Breakdown,
  DIMENSIONS,
  type DimensionValue,
  PI_BREAKDOWNS,
} from 'lumen/utils/constants/pi-constant-values';

// Countries list taken from Faker.js, but removed small/obscure countries
const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bangladesh',
  'Belarus',
  'Belgium',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Central African Republic',
  'Chile',
  'China',
  'Colombia',
  'Congo',
  'Costa Rica',
  "Cote d'Ivoire",
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Estonia',
  'Ethiopia',
  'Faroe Islands',
  'Falkland Islands (Malvinas)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Republic of Korea',
  'Kuwait',
  'Latvia',
  'Lebanon',
  'Liberia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nepal',
  'Netherlands Antilles',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norfolk Island',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Sierra Leone',
  'Singapore',
  'Slovakia (Slovak Republic)',
  'Slovenia',
  'Somalia',
  'South Africa',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tanzania',
  'Thailand',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

// Taken from Faker.js and filtered out half and shuffeled them
const streetNames = [
  'Waelchi',
  'Rice',
  'Schmitt',
  'Paucek',
  'Jones',
  'Purdy',
  'Balistreri',
  'Halvorson',
  'Von',
  'Okuneva',
  'Brakus',
  'Bergnaum',
  'Kuhn',
  'Breitenberg',
  'Miller',
  'Ankunding',
  'Pfeffer',
  'Hilpert',
  'Reinger',
  'Senger',
  'Gibson',
  'Bernhard',
  'Jerde',
  'Mohr',
  "O'Keefe",
  'Beahan',
  'Gerhold',
  'Keeling',
  'Little',
  'Schultz',
  'McLaughlin',
  'Hoeger',
  'Howell',
  'Bechtelar',
  'Sauer',
  'Mertz',
  'Nienow',
  'Herzog',
  'Schaden',
  'Sipes',
  'Runte',
  'Blick',
  'Jast',
  'Bahringer',
  'Quitzon',
  'Stehr',
  'Dach',
  'Kuphal',
  'Durgan',
  'Greenfelder',
  'McGlynn',
  'Barton',
  'Johnson',
  "O'Conner",
  'Rogahn',
  'Smith',
  'Kshlerin',
  'Kerluke',
  'Koss',
  'Jakubowski',
  'Bins',
  'Stoltenberg',
  'King',
  'Lueilwitz',
  'Huel',
  'Leuschke',
  'Hahn',
  'Parisian',
  'Botsford',
  'Yundt',
  'Farrell',
  'Bartell',
  'Collins',
  'Kautzer',
  'West',
  'Daniel',
  'Walsh',
  'Lemke',
  'Feil',
  'Tremblay',
  'Hirthe',
  'Wilkinson',
  'Klocko',
  'Hammes',
  'Heller',
  'Champlin',
  'Dietrich',
  'Rutherford',
  'Hilll',
  'Hettinger',
  'Batz',
  'Williamson',
  'Brown',
  'Bode',
  'Erdman',
  'Tillman',
  'Sanford',
  'Osinski',
  'Prohaska',
  'Hackett',
  'Leannon',
  'Windler',
  'Abshire',
  'Marks',
  'Kuhic',
  'Mayert',
  'Ritchie',
  'Schimmel',
  'Effertz',
  'Schroeder',
  'Jacobs',
  'Kunde',
  'Wiegand',
  'Cormier',
  'Renner',
  'Marvin',
  'Frami',
  'Stanton',
  'Lynch',
  'Moore',
  'Casper',
  'McCullough',
  'Weissnat',
  'Considine',
  'Abbott',
  'Murphy',
  'MacGyver',
  'Roberts',
  'Glover',
  'Veum',
  'Crooks',
  'Emard',
  'Feeney',
  'Rolfson',
  'Watsica',
  'Lowe',
  'Muller',
  'Buckridge',
  'Sporer',
  'Hermann',
  'Nitzsche',
  'Legros',
  'Lindgren',
  'Altenwerth',
  'Fadel',
  'Stiedemann',
  'Kozey',
  'Connelly',
  'Turner',
  'Runolfsdottir',
  'Bogan',
  'Ratke',
  'Kihn',
  'Larkin',
  'Auer',
  'Nader',
  'Mraz',
  'Boyle',
  'Baumbach',
  'Shields',
  'Cummerata',
  'Dibbert',
  'Roob',
  'Grady',
  'Dicki',
  'Daugherty',
  'Wyman',
  'Predovic',
  'Schuppe',
  'Carter',
  'Schoen',
  'Cole',
  'Zemlak',
  'Goodwin',
  'Funk',
  'Ledner',
  'Grant',
  'Witting',
  'Hegmann',
  'Gusikowski',
  'Gottlieb',
  'Harber',
  'Hartmann',
  'Zieme',
  'Hane',
  'Pouros',
  'Cremin',
  'Wuckert',
  'Klein',
  'Thiel',
  'Beier',
  'Kreiger',
  'Ondricka',
  'Heaney',
  'Reichert',
  'Koelpin',
  'Hoppe',
  'Swift',
  'Schmeler',
  'Padberg',
  'Upton',
  'Kohler',
  'Oberbrunner',
  'Tromp',
  'Mann',
  'Fisher',
  'Deckow',
  'Streich',
  'Raynor',
  'Lakin',
  'Langosh',
  'Ward',
  'Schamberger',
  'Toy',
  'Morissette',
  'Strosin',
  'Kuvalis',
  'Spencer',
  'Kessler',
  'Rowe',
  'Grimes',
  'Torphy',
  'Gutmann',
  'Wisoky',
  'Dooley',
  'Borer',
  'Bednar',
  'Wolf',
  'Crona',
  'Gleason',
  'Mitchell',
  'Friesen',
  'Wehner',
  'Orn',
  'Hauck',
  'Doyle',
];

// Taken from Faker.js and filtered out half and shuffeled them
const streetSuffixes = [
  'Shores',
  'Inlet',
  'Ranch',
  'Roads',
  'Cliffs',
  'Square',
  'Street',
  'Oval',
  'Junction',
  'Ridge',
  'Village',
  'Creek',
  'Ports',
  'Station',
  'Terrace',
  'Park',
  'Dale',
  'Port',
  'Divide',
  'Cove',
  'Forest',
  'Walk',
  'Mission',
  'Squares',
  'Stravenue',
  'Turnpike',
  'Mountain',
  'Spurs',
  'Extensions',
  'Stream',
  'Trail',
  'Springs',
  'Villages',
  'Neck',
  'Spring',
  'Harbor',
  'Court',
  'Row',
  'Rapids',
  'Mill',
  'Ways',
  'Burg',
  'Falls',
  'Estate',
  'Parkway',
  'Manors',
  'Road',
  'Path',
  'Point',
  'Circles',
  'Wall',
  'Key',
  'Vista',
  'Drive',
  'Branch',
  'Brook',
  'Field',
  'Summit',
  'Forks',
  'Freeway',
  'Prairie',
  'Mountains',
  'Plaza',
  'Pine',
  'Locks',
  'Highway',
  'Glen',
  'Causeway',
  'Island',
  'Wells',
  'Shoals',
  'Meadows',
  'Haven',
  'Flat',
  'Crossroad',
  'Radial',
  'Union',
  'Lake',
  'Common',
  'Centers',
  'Tunnel',
  'Lights',
  'Corners',
  'Green',
  'Alley',
  'Trace',
  'Lane',
  'River',
  'Pass',
  'Hills',
  'Crest',
  'Grove',
  'Trafficway',
  'Place',
  'Forges',
  'Run',
  'Bypass',
  'Plains',
  'Mall',
  'Canyon',
  'Via',
  'Motorway',
  'Gardens',
  'Lock',
  'Isle',
  'Knoll',
  'Land',
  'Lodge',
  'Islands',
  'Ford',
  'Valley',
  'Expressway',
  'View',
];

const brandSuffixes = [
  'Hotels',
  'Group',
  'Resorts',
  'Inns',
  'Suites',
  'Hospitality',
];

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateCountryName(seed: number) {
  return `${countries.at(seed % countries.length)}`;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateBrandName(seed: number) {
  const brandName = streetNames.at(seed % streetNames.length);
  const brandSuffix = brandSuffixes.at(seed % brandSuffixes.length);
  return `${brandName} ${brandSuffix}`;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateHotelName(seed: number) {
  const streetName = streetNames.at(seed % streetNames.length);
  const streetSuffix = streetSuffixes.at(seed % streetSuffixes.length);
  return `${streetName} ${streetSuffix} Hotel`;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateGenericName(seed: number) {
  return `${streetNames.at(seed % countries.length)}`;
}

/**
 * Generates a hash for a string value
 * @param  {String} value A string value for which to generate a hash
 * @return {Number}       A hash code representing the original value
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateHashCode(value: string) {
  let hashCode = 0;
  let charIndex = 0;

  // https://stackoverflow.com/a/7616484/6362632
  // JS implementation of JAVA hashCode Object method
  while (charIndex < value.length) {
    hashCode =
      ((hashCode << 5) - hashCode + value.charCodeAt(charIndex++)) << 0;
  }

  return hashCode + 7;
}

/**
 * Generates a fake name by a given value obj for PA markets/brands/hotels in general
 * The fake name will be generated consistently depending on the hash of the segmentation value
 * @param  {Object} segmentationValue Segmentation value object to transform
 * @param  {String} suffix            Text bit to put at the end for more custom feel in the names (e.g. Hotels, Group)
 * @return {String}                   A random name by a given seed with a custom optional suffix
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function generateFakeName(
  segmentationValue: string,
  dimension: Breakdown | DimensionValue,
) {
  const hashedSeed = generateHashCode(segmentationValue);

  if (
    dimension === PI_BREAKDOWNS.MARKET_ID ||
    dimension === DIMENSIONS.MARKET
  ) {
    return generateCountryName(hashedSeed);
  }

  if (dimension === PI_BREAKDOWNS.BRAND_ID || dimension === DIMENSIONS.BRAND) {
    return generateBrandName(hashedSeed);
  }

  if (
    dimension === PI_BREAKDOWNS.SUBSCRIPTION_ID ||
    dimension === DIMENSIONS.HOTEL
  ) {
    return generateHotelName(hashedSeed);
  }

  return generateGenericName(hashedSeed);
}

export default generateFakeName;
